import PendoIcon from '../icon/pendo-icon.vue.js';

var script = {
  name: 'PendoEmptyState',
  components: {
    PendoIcon
  },
  props: {
    icon: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    },
    backgroundColor: {
      type: String,
      default: '#FFF'
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-empty-state.vue2.js.map
